/**
 * KYC survey options — hardcoded Spanish strings.
 * Source: AngularJS app.constants.ts KYC_OPTIONS
 */

export const KYC_OPTIONS = {
  position: [
    'Dueño',
    'Jefe de Taller',
    'Asistente administrativo',
    'Técnico',
    'Otro',
  ],
  employeesQuantity: [
    'Soy solo yo',
    'de 2 a 5',
    '6 a 10',
    '11 a 15',
    '16 o más',
    'Todavía ninguno',
  ],
  hasAssistant: ['Sí', 'No'],
  weeklyServices: ['1 - 5', '6 - 15', '16 - 30', '31 o más'],
  servicesTypes: [
    'Reparaciones y Mantenimiento',
    'Detallado, envolturas y películas',
    'Restauración y Personalización',
    'Hojalatería y Pintura',
    'Otros',
  ],
  vehiclesTypes: [
    'Autos',
    'Semi y Pesados',
    'Trailers',
    'Caravanas',
    'Motos',
    'Bicis',
    'Botes',
  ],
  lookingToSolve: [
    'Servicio al Cliente',
    'Aumentar Postventa',
    'Mejorar la administración',
    'Productividad del personal',
  ],
  currentManagement: ['Papel', 'Excel', 'Uso una App/Software'],
  currentProblems: [
    'Coordinación de agenda',
    'Historial de servicios',
    'Retención de clientes',
    'Reseñas de Google',
    'Métricas',
    'Productividad de empleados',
    'Inventario',
    'Gestión de proveedores',
    'Consultas de progreso',
    'Claridad en cobranza',
    'Demoras en entrega de refacciones',
  ],
  clientTypes: ['Particular', 'Empresas', 'Flotillas'],
  communicationMethods: ['WhatsApp', 'Llamadas', 'En persona', 'Redes sociales'],
  hasMultipleBranches: ['Sí', 'No'],
  branchCount: ['2-3', '4-10', '11+'],
  hasDefinedProcesses: ['Sí', 'No'],
  consultingNeeds: [
    'Aumentar ventas',
    'Mejorar procesos',
    'Mejor servicio al cliente',
    'Agilizar la obtención de refacciones',
    'Aumentar el ticket promedio',
  ],
  hasTesterReady: ['Sí, mi equipo está listo', 'No, solo yo'],
  implementationTimeline: ['Urgente', 'Solo estoy probando', 'No definido'],
} as const;

export type KycOptionKey = keyof typeof KYC_OPTIONS;
